export default __webpack_public_path__ + "static/media/924.ec0db683.png";